import { SortDirections } from 'constants/sortDirections';

export const orderByNameAsc = { direction: SortDirections.asc, field: 'name' };
